// constants
import { showSuccessAlert } from "../../constants/alerts";
import { CorporateActionTypes } from "./constants";

const INIT_STATE = {
  corporates: [],
  loading: false,
  initialLoading: false,
  error: null,
  pagination: null,
};

interface CorporateActionType {
  type:
    | CorporateActionTypes.API_RESPONSE_SUCCESS
    | CorporateActionTypes.API_RESPONSE_ERROR
    | CorporateActionTypes.GET_CORPORATES
    | CorporateActionTypes.ADD_CORPORATES
    | CorporateActionTypes.UPDATE_CORPORATES
    | CorporateActionTypes.DELETE_CORPORATES
    | CorporateActionTypes.CLEAR_ERROR;
  payload: any;
}

const Corporates = (state: any = INIT_STATE, action: CorporateActionType): any => {
  switch (action.type) {
    case CorporateActionTypes.API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case CorporateActionTypes.GET_CORPORATES:
          return {
            ...state,
            corporates: action.payload.data?.data?.data || action.payload.data,
            pagination: action.payload?.data?.data?.pagination || null,
            loading: false,
            initialLoading: false,
            error: null,
          };

        case CorporateActionTypes.ADD_CORPORATES:
        case CorporateActionTypes.UPDATE_CORPORATES:
        case CorporateActionTypes.DELETE_CORPORATES:
          showSuccessAlert(action.payload.data);
          return { ...state, loading: false, error: null };

        default:
          return { ...state };
      }

    case CorporateActionTypes.API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case CorporateActionTypes.GET_CORPORATES:
          return { ...state, error: action.payload.error, loading: false, initialLoading: false };
        case CorporateActionTypes.ADD_CORPORATES:
        case CorporateActionTypes.UPDATE_CORPORATES:
        case CorporateActionTypes.DELETE_CORPORATES:
          return { ...state, error: action.payload.error, loading: false };
        default:
          return { ...state };
      }

    case CorporateActionTypes.GET_CORPORATES:
      return { ...state, loading: true, initialLoading: true };
    case CorporateActionTypes.ADD_CORPORATES:
    case CorporateActionTypes.UPDATE_CORPORATES:
    case CorporateActionTypes.DELETE_CORPORATES:
      return { ...state, loading: true };

    case CorporateActionTypes.CLEAR_ERROR:
      return { ...state, error: null };

    default:
      return { ...state };
  }
};

export default Corporates;
